import { all, put, takeLatest } from "redux-saga/effects";

// Api
import { getLocationSummaryFn } from "../../apis/LocationSummaryAPI";
import {
  getRegionByCoordinatesFn,
  getRegionPopulationFactorFn,
} from "../../apis/RegionAPI";

// Constants
import { LocationSummary } from "../../constants/action-constants/LocationSummaryActionConstants";

function getUpdatedDataWithPopulationFactor(result = {}, populationFactor) {
  if (!populationFactor || populationFactor <= 0) {
    return result;
  }

  // total population
  const total = result?.summary?.population?.total;

  // if no population present in result, return result as it is
  if (!total) {
    return result;
  }

  // update population with population factor
  const updatedTotal = total * populationFactor;
  const updatedPopulation = {
    ...result.summary.population,
    total: updatedTotal,
  };
  const updatedSummary = {
    ...result.summary,
    population: updatedPopulation,
  };
  const updatedResult = {
    ...result,
    summary: updatedSummary,
  };

  return updatedResult;
}

export function* getLocationSummary(action) {
  try {
    const { latitude, longitude, distance } = action.payload;

    // location summary
    const { result } = yield getLocationSummaryFn(
      latitude,
      longitude,
      distance
    );

    // getting regionData from latitude and longitude
    const { id: cityId } = yield getRegionByCoordinatesFn(latitude, longitude);

    // getting population factor for the city
    const populationFactor = yield getRegionPopulationFactorFn(cityId);

    // update result population with population factor
    const updatedResult = getUpdatedDataWithPopulationFactor(
      result,
      populationFactor
    );

    // dispatching action
    yield put({
      type: LocationSummary.GET_LOCATION_SUMMARY_SUCCESS,
      data: updatedResult,
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: LocationSummary.GET_LOCATION_SUMMARY_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(LocationSummary.GET_LOCATION_SUMMARY, getLocationSummary),
  ]);
}
